import { render, staticRenderFns } from "./tica-modal-template.vue?vue&type=template&id=4ffc002a"
import script from "./tica-modal-template.vue?vue&type=script&lang=js"
export * from "./tica-modal-template.vue?vue&type=script&lang=js"
import style0 from "./tica-modal-template.vue?vue&type=style&index=0&id=4ffc002a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports